import React from "react";
import { Button, Spinner } from "reactstrap";

const NextButton = ({ type, next, disabled, label, loading }) => {
  return (
    <Button
      type={type ? type : ""}
      onClick={next ? next : () => { }}
      color="primary"
      disabled={disabled}
      className="btn btn-primary d-flex align-items-center justify-content-center text-center py-0  ms-auto"
      style={{ width: "200px" }}
    >
      {loading && loading ? (
        <Spinner color="dark" size="sm" className="me-2">
          {" "}
          Loading...{" "}
        </Spinner>
      ) : null}
      {label ? label : "Next"}{" "}
      <i className="ri-arrow-right-line  align-middle fs-2 ms-2"></i>
    </Button>
  );
};

export default NextButton;
